import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon, BoxIcon, FileTextIcon, LockIcon, UserIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { Seal } from '../brand/Seal';
import { useBrand } from '../../contexts/BrandContext';
const marks = [{
  icon: UserIcon,
  label: 'Licensed clinicians',
  detail: 'In all 50 states'
}, {
  icon: LockIcon,
  label: 'Secure & private',
  detail: 'HIPAA-compliant'
}, {
  icon: FileTextIcon,
  label: 'Transparent pricing',
  detail: 'Published up front'
}, {
  icon: BoxIcon,
  label: 'Discreet delivery',
  detail: 'Unbranded, cold-chain'
}];
export function Hero() {
  const {
    brand
  } = useBrand();
  return <section className="bg-cream" data-id="element-49" data-mp="3rxqf8yc9iub8">
      <div className="mx-auto max-w-shell px-6 pb-10 pt-12 md:px-8 md:pb-14 md:pt-20" data-id="element-50" data-mp="3ryhyd9ooazkm">
        <div className="grid items-end gap-10 lg:grid-cols-[1.15fr_0.85fr] lg:gap-16" data-id="element-51" data-mp="1v3vdfj1ms7f9">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-52" data-mp="1q6lnm2abxtqw">
            <h1 className="font-serif text-[3.25rem] leading-[0.98] text-ink sm:text-7xl lg:text-[5.75rem]" data-id="element-53" data-mp="1rwgr1y2e87ow">
              {brand.copy.heroTitle[0]}
              <br data-id="element-54" data-mp="1d0iz6rzi5pih" />
              {brand.copy.heroTitle[1]}
            </h1>
            <p className="mt-8 max-w-lg text-lg leading-relaxed text-ink-soft" data-id="element-55" data-mp="1hxhtpbn2vyh7">
              {brand.copy.heroSubhead}
            </p>
            <div className="mt-10 flex flex-wrap items-center gap-4" data-id="element-56" data-mp="2alngs51ltzk7">
              <Button to="/get-started" data-id="element-57" data-mp="2anzug60bxnrg">
                Start your intake
                <ArrowRightIcon className="h-4 w-4" data-id="element-58" data-mp="1vwhjimmbujey" />
              </Button>
              <Link to="/programs" className="group inline-flex items-center gap-2 text-sm text-ink transition-colors duration-150 ease-republic hover:text-brick" data-id="element-59" data-mp="20vbzlgswttvd">
                See what {brand.name} can do for you
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-republic group-hover:translate-x-1" data-id="element-60" data-mp="338er595qy5wc" />
              </Link>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.98
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.55,
          delay: 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative" data-id="element-61" data-mp="2y7hch6jy3tzl">
            <img src={brand.images.hero} alt={`A ${brand.name} patient photographed in the studio`} className="aspect-[4/5] w-full rounded-brand object-cover" data-id="element-62" data-mp="2kakmt8fkcika" />
            <Seal className="absolute -left-6 -top-6 hidden h-24 w-24 text-brick lg:block" data-id="element-63" data-mp="2akiziiv1b46f" />
          </motion.div>
        </div>

        <div className="rule mt-14 pt-8" data-id="element-64" data-mp="26g1i2qc5d2yt">
          <ul className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:divide-x lg:divide-ink/10" data-id="element-65" data-mp="21jb0tzolw1bt">
            {marks.map(mark => <li key={mark.label} className="flex items-start gap-4 lg:px-6 lg:first:pl-0" data-id="element-66" data-mp="1wkgjl26aektt">
                <mark.icon className="mt-0.5 h-5 w-5 shrink-0 text-brick" strokeWidth={1.4} data-id="element-67" data-mp="c1e41wjdet0s" />
                <div data-id="element-68" data-mp="gzpcq3xxixhf">
                  <p className="text-sm font-medium text-ink" data-id="element-69" data-mp="h33htjxz9ksk">{mark.label}</p>
                  <p className="mt-1 text-sm text-ink-muted" data-id="element-70" data-mp="m0lhejq3unnw">{mark.detail}</p>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}